import { render, staticRenderFns } from "./Sorted.vue?vue&type=template&id=1d589184&scoped=true&lang=pug&"
import script from "./Sorted.vue?vue&type=script&lang=js&"
export * from "./Sorted.vue?vue&type=script&lang=js&"
import style0 from "./Sorted.vue?vue&type=style&index=0&id=1d589184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d589184",
  null
  
)

export default component.exports